<template>
  <div class="d-flex">
    <div>
      <p class="detail-table-name">Unpaid Absent Day</p>
      <table class="detail-table w-100">
        <thead>
          <tr>
            <th></th>
            <th>Unpaid Leave</th>
            <th>Child Nursing Care, etc. Leave</th>
            <th>Family Care Leave</th>
            <th>Flexible Work Leave for Child Care</th>
            <th>Others</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="unpaidAbsentDayByMonth">
            <td>Month</td>
            <td>{{ unpaidAbsentDayByMonth.unpaidLeave }}</td>
            <td>{{ unpaidAbsentDayByMonth.childCareLeave }}</td>
            <td>{{ unpaidAbsentDayByMonth.familyCare }}</td>
            <td>{{ unpaidAbsentDayByMonth.flexibleWorkLeaveForChildCare }}</td>
            <td>{{ unpaidAbsentDayByMonth.other }}</td>
          </tr>
          <tr v-if="unpaidAbsentDayByYear">
            <td>Academic Year</td>
            <td>{{ unpaidAbsentDayByYear.unpaidLeave }}</td>
            <td>{{ unpaidAbsentDayByYear.childCareLeave }}</td>
            <td>{{ unpaidAbsentDayByYear.familyCare }}</td>
            <td>{{ unpaidAbsentDayByYear.flexibleWorkLeaveForChildCare }}</td>
            <td>{{ unpaidAbsentDayByYear.other }}</td>
          </tr>
        </tbody>
      </table>
      <p class="unit-name">Unit: Days</p>
    </div>
  </div>
</template>

<script lang="ts">
import _ from 'lodash'
import { Component, Prop, Vue } from 'vue-property-decorator'
import { Moment } from 'moment'
import { term as Term, Timesheet, UnpaidAbsentDay } from '@/store/timesheets/types'

@Component
export default class UnpaidAbsentDayComponent extends Vue {
  @Prop() date!: Moment

  @Prop() unpaidAbsentDays!: UnpaidAbsentDay[]

  private get unpaidAbsentDayByMonth(): UnpaidAbsentDay|undefined {
    return this.unpaidAbsentDayByTerm('month')
  }

  private get unpaidAbsentDayByYear(): UnpaidAbsentDay|undefined {
    return this.unpaidAbsentDayByTerm('fiscalYear')
  }

  private unpaidAbsentDayByTerm(term: Term): UnpaidAbsentDay|undefined {
    return this.unpaidAbsentDays.find(
      (unpaidAbsentDay: UnpaidAbsentDay) => unpaidAbsentDay.term === term,
    )
  }
}
</script>

<style scoped>
.detail-table-name {
  border-left:3px solid #BFBFBF;
  padding-left:5px;
  margin-bottom:10px;
  font-weight: bold;
}

.detail-table {
  table-layout: fixed;
  border-collapse:collapse;
  margin-bottom:10px;
}

.detail-table th {
  padding:10px;
  text-align: center;
}

.detail-table td {
  padding:10px;
  text-align: center;
}

.detail-table thead tr {
  background: #fff;
  border: 2px solid #dcdcdc
}

.detail-table tbody tr:nth-child(odd) {
  background: #D8D8D8;
}

.detail-table tbody tr:nth-child(even) {
  background: #fff;
}

.detail-table tbody tr.total {
  background: #D8E2F3;
}

.unit-name {
  text-align: right;
}
</style>
